// v1.19.1 · Política de privacidad y eliminación de datos (pública: la piden Meta, WhatsApp y Google para las apps).
import React from 'react';
import { Link } from 'react-router-dom';
import { contactData, LOGO } from '../data/site';

const UPDATED = '26 de octubre de 2026';

function Section({ id, title, children }) {
  return (
    <section id={id} className="scroll-mt-6 space-y-2">
      <h2 className="text-lg font-bold text-[#0F2A3A]">{title}</h2>
      <div className="space-y-2 text-[15px] leading-relaxed text-gray-700">{children}</div>
    </section>
  );
}

export default function PrivacyPage() {
  const mail = contactData.email;
  return (
    <div className="min-h-screen bg-[#EEF0F3] px-4 py-8">
      <div className="mx-auto max-w-3xl">
        <Link to="/" className="mb-5 inline-block"><img src={LOGO} alt="Analytica" className="h-10 w-auto" /></Link>
        <article className="space-y-6 rounded-2xl border border-gray-200 bg-white p-5 shadow-sm sm:p-8" data-testid="privacy-page">
          <header>
            <h1 className="text-2xl font-extrabold text-[#0F2A3A] sm:text-3xl">Política de privacidad</h1>
            <p className="mt-1 text-sm text-gray-500">Última actualización: {UPDATED}</p>
          </header>
          <p className="text-[15px] leading-relaxed text-gray-700">
            En Analytica (fábrica de software con oficina en {contactData.address}, Quito, Ecuador) cuidamos los datos personales de quienes
            nos escriben o usan nuestros servicios. Esta política explica qué datos recogemos, para qué, con quién los compartimos y cómo
            puede pedir que los eliminemos, conforme a la Ley Orgánica de Protección de Datos Personales del Ecuador.
          </p>
          <Section id="datos" title="1. Qué datos recogemos">
            <p>Solo los que usted nos entrega o los que se generan cuando nos contacta:</p>
            <ul className="list-disc space-y-1 pl-5">
              <li>Nombre, correo, teléfono, empresa y cargo, cuando llena un formulario de nuestro sitio, agenda una reunión o responde un formulario de Facebook.</li>
              <li>Lo que nos cuenta sobre su necesidad (por ejemplo, el proceso que quiere mejorar, el tamaño de su empresa o el plazo).</li>
              <li>Los mensajes que nos envía por WhatsApp, correo o redes sociales, y nuestras respuestas.</li>
              <li>Datos de campaña (de qué anuncio o publicación llegó) para medir qué funciona.</li>
            </ul>
            <p>No pedimos ni guardamos contraseñas, números de tarjeta ni datos sensibles a través de estos canales.</p>
          </Section>
          <Section id="uso" title="2. Para qué los usamos">
            <ul className="list-disc space-y-1 pl-5">
              <li>Responder su consulta, agendar y realizar la reunión que pidió y preparar una propuesta o un demo.</li>
              <li>Darle seguimiento comercial mientras su consulta esté abierta.</li>
              <li>Publicar contenido en nuestras páginas y medir los resultados de nuestras campañas.</li>
            </ul>
            <p>No vendemos sus datos. Puede pedir en cualquier momento que no le volvamos a contactar.</p>
          </Section>
          <Section id="asistente" title="3. Asistente automático">
            <p>En WhatsApp puede atenderle primero un asistente virtual con inteligencia artificial que responde preguntas generales y agenda
              reuniones. Las conversaciones quedan en nuestro sistema para que el equipo las revise; puede pedir hablar con una persona en cualquier momento.</p>
          </Section>
          <Section id="terceros" title="4. Con quién los compartimos">
            <p>Usamos proveedores que procesan los datos por cuenta nuestra y solo para estos fines: Meta (Facebook y WhatsApp), Google (calendario y
              correo), proveedores de correo electrónico, de inteligencia artificial y el alojamiento de nuestro sistema. Ninguno puede usarlos para fines propios.</p>
          </Section>
          <Section id="plazos" title="5. Cuánto tiempo los guardamos">
            <p>Mientras exista una relación comercial o una consulta abierta, y después solo el tiempo necesario para cumplir obligaciones legales.
              Los contactos que no avanzan se eliminan o anonimizan a pedido o cuando dejan de ser necesarios.</p>
          </Section>
          <Section id="eliminar" title="6. Sus derechos y cómo eliminar sus datos">
            <p>Puede pedir acceso, corrección, eliminación u oposición al tratamiento de sus datos. Para eliminarlos:</p>
            <ol className="list-decimal space-y-1 pl-5">
              <li>Escríbanos a <a className="font-semibold text-[#2F3D8E] underline" href={`mailto:${mail}?subject=Eliminar%20mis%20datos`}>{mail}</a> con el asunto «Eliminar mis datos», o pídalo por WhatsApp al {contactData.whatsapp}.</li>
              <li>Indique el correo o el teléfono con el que nos contactó.</li>
              <li>Eliminaremos sus datos de nuestro sistema en un plazo máximo de 15 días y le confirmaremos por el mismo medio.</li>
            </ol>
            <p>Si nos contactó desde Facebook o Instagram, también puede quitar el acceso de nuestra app en la configuración de su cuenta de Facebook
              («Apps y sitios web»); al recibir ese aviso eliminamos los datos asociados.</p>
          </Section>
          <Section id="contacto" title="7. Contacto">
            <p>Responsable: Analytica · {contactData.address}, Quito, Ecuador · <a className="text-[#2F3D8E] underline" href={`mailto:${mail}`}>{mail}</a></p>
          </Section>
        </article>
      </div>
    </div>
  );
}
